export function resolveSynergy(lineup) {
    const counts = new Map();
    for (const slot of lineup.slots) {
        const g = slot.member.groupId;
        counts.set(g, (counts.get(g) ?? 0) + 1);
    }
    const triggers = [];
    for (const [groupId, count] of counts) {
        if (count >= 3)
            triggers.push({ groupId, count, doubled: count === 5 });
    }
    return triggers;
}
